export const SET_UPLOAD_RESULTS = 'SET_UPLOAD_RESULTS';
export const SET_FILE_NAME = 'SET_FILE_NAME';